import { render, staticRenderFns } from "./customerData.vue?vue&type=template&id=158dab78&"
import script from "./customerData.vue?vue&type=script&lang=js&"
export * from "./customerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports